"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigDataChannel = exports.BuildBigDataChannel = void 0;
var util_1 = require("../../util");
var request_1 = require("./request");
var controller_1 = require("../../controller");
/**
 * 纯后台字段，目前各品类都是0
 */
var sessionType = 0;
/**
 * 提交 CGI
 */
var commitRequestUrl = '/dop-api/commitchanges';
/**
 * CGI 请求 body 上限
 */
var bigChangesRequestBodyMaximum = 20 * 1024 * 1024;
/**
 * 大数据通道, 支持大数据提交、批量消息发送
 *
 * @class BigDataChannel
 * @implements {IBigDataChannel}
 */
var BigDataChannel = /** @class */ (function () {
    function BigDataChannel(options, dependency) {
        this.options = options;
        this.dependency = dependency;
    }
    BigDataChannel.prototype.dispose = function () {
        util_1.ConnectionLog.warn('BigDataChannel dispose.');
    };
    /**
     * 大数据发送
     *
     * @param {IRoomSendMessagePacket} message
     */
    BigDataChannel.prototype.sendMessage = function (message) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var preCheckResult, messages, bigChangesCommitResult;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        preCheckResult = this.preCheck(message);
                        if (!(preCheckResult.errCode === 0 && typeof message.data === 'object')) return [3 /*break*/, 2];
                        messages = [message.data];
                        return [4 /*yield*/, this.bigChangesCommit(messages)];
                    case 1:
                        bigChangesCommitResult = _c.sent();
                        util_1.ConnectionLog.info("bigChangesCommitResult : " + bigChangesCommitResult.success + " retcode:" + bigChangesCommitResult.retCode + " bodyLength:" + bigChangesCommitResult.bodyLength);
                        if (bigChangesCommitResult.success) {
                            (_a = bigChangesCommitResult.data) === null || _a === void 0 ? void 0 : _a.forEach(function (newChanges) {
                                var _a;
                                // 自己提交的通过cb回调，push的数据通过注入依赖回调
                                if (newChanges.commitId === message.taskId) {
                                    var sendMessageResult = {
                                        errCode: 0,
                                        response: {
                                            new_rev: newChanges.new_rev,
                                            body: {
                                                data: {
                                                    changeset: newChanges.changeset,
                                                    author: newChanges.author,
                                                    changesetType: newChanges.changesetType,
                                                    commitId: newChanges.commitId,
                                                    subid: newChanges.subId,
                                                    applyTime: newChanges.applyTime,
                                                }
                                            }
                                        },
                                    };
                                    (_a = message.onsendAccept) === null || _a === void 0 ? void 0 : _a.call(message, newChanges.commitId, "USER_CHANGES" /* USER_CHANGES */, message.data, "ACCEPT_COMMIT" /* ACCEPT_COMMIT */, sendMessageResult);
                                }
                                else {
                                    var serverMessage = _this.createServerMessage(newChanges);
                                    _this.dependency.receiveMessageFromServer("NEW_CHANGES" /* NEW_CHANGES */, [serverMessage]);
                                }
                            });
                        }
                        else {
                            message.onError(message.taskId, message.cmd, message.data, {
                                errCode: (_b = bigChangesCommitResult.retCode) !== null && _b !== void 0 ? _b : 52000 /* UNKNOWN_ERROR */,
                                errMsg: bigChangesCommitResult.reason,
                            });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        message.onError(message.taskId, message.cmd, message.data, preCheckResult);
                        _c.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 批量提交接口，异步返回结果
     *
     * @param {IUserChange[]} messages
     * @param {number} [curVersion]
     * @returns {Promise<IBatchCommitChangesResult>}
     */
    BigDataChannel.prototype.batchCommitMessages = function (messages, curVersion, otherOption) {
        return __awaiter(this, void 0, void 0, function () {
            var content, batchChangesRequestResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        content = this.packUserChanges(messages, curVersion, otherOption);
                        return [4 /*yield*/, this.batchChangesRequest(this.options.serverVars.globalPadId, content, otherOption)];
                    case 1:
                        batchChangesRequestResult = _a.sent();
                        return [2 /*return*/, this.getCommitResult(batchChangesRequestResult, curVersion)];
                }
            });
        });
    };
    /**
     * 异步发送
     *
     * @private
     * @param {string} padId
     * @param {Object} offlineData
     * @returns
     */
    BigDataChannel.prototype.batchChangesRequest = function (padId, offlineData, otherOption) {
        return __awaiter(this, void 0, void 0, function () {
            var xsrf, url, content, parameter;
            return __generator(this, function (_a) {
                xsrf = util_1.Cookie.getXsrf();
                url = commitRequestUrl + "?padId=" + padId + "&xsrf=" + xsrf + "&" + ((otherOption === null || otherOption === void 0 ? void 0 : otherOption.urlParameter) ? otherOption === null || otherOption === void 0 ? void 0 : otherOption.urlParameter : '');
                content = util_1.JsonUtil.jsonStringify(offlineData);
                // 先注释，暂时去掉encode
                content = encodeURIComponent(content);
                parameter = {
                    url: url,
                    method: request_1.Method.POST,
                    body: "data=" + content,
                    contentType: request_1.ContentType.FORM,
                };
                return [2 /*return*/, new request_1.Request().sendCommonRequest(parameter)];
            });
        });
    };
    BigDataChannel.prototype.bigChangesCommit = function (messages) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var content, body, batchChangesRequestResult;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        content = this.packUserChanges(messages);
                        body = this.bigChangesRequestBody(this.options.serverVars.globalPadId, content);
                        if (body.length >= (((_b = (_a = this.options.config) === null || _a === void 0 ? void 0 : _a.bigDataCommitConfig) === null || _b === void 0 ? void 0 : _b.maxContentLength) || bigChangesRequestBodyMaximum)) {
                            return [2 /*return*/, {
                                    success: false,
                                    retCode: 52003 /* CONTENT_LENGTH_EXCEED_LIMIT */,
                                    bodyLength: body.length,
                                    data: [],
                                }];
                        }
                        return [4 /*yield*/, this.bigChangesRequest(body)];
                    case 1:
                        batchChangesRequestResult = _c.sent();
                        return [2 /*return*/, this.getCommitResult(batchChangesRequestResult)];
                }
            });
        });
    };
    BigDataChannel.prototype.bigChangesRequest = function (body) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var parameter;
            return __generator(this, function (_c) {
                parameter = {
                    url: commitRequestUrl,
                    method: request_1.Method.POST,
                    body: body,
                    contentType: request_1.ContentType.JSON,
                    timeout: (_b = (_a = this.options.config) === null || _a === void 0 ? void 0 : _a.bigDataCommitConfig) === null || _b === void 0 ? void 0 : _b.timeout,
                };
                return [2 /*return*/, new request_1.Request().sendCommonRequest(parameter)];
            });
        });
    };
    BigDataChannel.prototype.bigChangesRequestBody = function (padId, offlineData) {
        var xsrf = util_1.Cookie.getXsrf();
        var body = util_1.JsonUtil.jsonStringify({
            padId: padId,
            xsrf: xsrf,
            commitData: offlineData,
        });
        return body;
    };
    BigDataChannel.prototype.getCommitResult = function (requestResult, curVersion) {
        var _a, _b;
        var result = {
            success: false,
            retCode: 0 /* SUCCESS */,
            data: [],
        };
        if (requestResult.error) {
            // 网络原因提交出错了
            result.type = "NetworkException" /* NETWORK_EXCEPTION */;
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var statusCode = (_a = requestResult.error) === null || _a === void 0 ? void 0 : _a.statusCode;
            var payloadTooLargeCode = 413;
            if (statusCode === payloadTooLargeCode) {
                result.retCode = 52003 /* CONTENT_LENGTH_EXCEED_LIMIT */;
            }
            util_1.ConnectionLog.info("batchCommitMessages: " + ((_b = requestResult.error) === null || _b === void 0 ? void 0 : _b.message) + ", statusCode:" + statusCode);
            return result;
        }
        try {
            var response = JSON.parse(requestResult.data);
            if ((response === null || response === void 0 ? void 0 : response.retcode) === 0 /* SUCCESS */) {
                response.Data.respective.forEach(function (item) {
                    var _a;
                    util_1.ConnectionLog.info("batchCommitMessages rev:" + curVersion + ", newRev:" + item.newRev + ", taskId:" + item.commitId);
                    // 注意commitParams?.rev可能会为0
                    (_a = result.data) === null || _a === void 0 ? void 0 : _a.push(item);
                });
                result.type = "Success" /* SUCCESS */;
                result.success = true;
                result.common = response.Data.common;
            }
            else {
                // 权限服务区或者hackpad提交错误
                result.retCode = response.retcode;
                result.type = "ServerVerityException" /* SERVER_VERITY_EXCEPTION */;
                result.reason = response.retmsg;
                util_1.ConnectionLog.info("batchCommitMessages retcode:" + (response === null || response === void 0 ? void 0 : response.retcode) + " retmsg:" + (response === null || response === void 0 ? void 0 : response.retmsg));
            }
        }
        catch (error) {
            util_1.ConnectionLog.warn("getCommitResult parseJson error, data: " + requestResult.data + ".");
            result.type = "NetworkException" /* NETWORK_EXCEPTION */;
        }
        return result;
    };
    /**
     * 检查发送消息合法性
     *
     * @private
     * @param {IRoomSendMessagePacket} message
     * @returns {IRoomSendMessageResult}
     */
    BigDataChannel.prototype.preCheck = function (message) {
        var result = {
            errCode: 0 /* SUCCESS */,
        };
        if (!message.data || typeof message.data === 'string') {
            result.errMsg = 'send data type is conrect.';
            result.errCode = 52001 /* PARAMETER_WRONG */;
        }
        return result;
    };
    /**
     * 批量消息组包，包含公共包头common和消息数组respective
     *
     * @private
     * @param {Array<IUserChange>} changes
     * @returns
     */
    BigDataChannel.prototype.packUserChanges = function (changes, curRev, otherOption) {
        var _this = this;
        var _a;
        var change = changes[0];
        var content = {
            common: __assign(__assign({}, otherOption === null || otherOption === void 0 ? void 0 : otherOption.additionalFieldsToCommon), { type: "USER_CHANGES" /* USER_CHANGES */, curRev: curRev, offlineMsg: true, docid: this.options.serverVars.globalPadId, uid: this.options.uid, dver: this.options.serverVars.dver, base_rev: change.baseRev, code_ver: 0, session_type: sessionType, gray: this.options.serverVars.gray || 0, generalpacket: (_a = this.options.config) === null || _a === void 0 ? void 0 : _a.headerGeneralPacket, pver: this.options.serverVars.pver, uuId: this.options.uuId }),
            respective: changes.map(function (userChange) { return _this.getRespectiveItem(userChange); }),
        };
        return content;
    };
    BigDataChannel.prototype.getRespectiveItem = function (userChange) {
        var item = {
            task_id: userChange.taskId,
            subId: userChange.subId,
            oSubId: userChange.oSubId || false,
            head: userChange.head || false,
            keydata: userChange.keydata || false,
            changeSetCount: userChange.changeSetCount || 1,
            changeset: userChange.changeset,
            changesetType: userChange.changesetType,
            apool: userChange.apool,
            isWorkbook: userChange.isWorkbook,
        };
        if (this.options.module === controller_1.DOCUMENT_TYPE.DOC) {
            // doc 不使用 changeset 字段上行，不能使用??, base64Commands 不会为 undefined
            item.commands = userChange.base64Commands || userChange.changeset;
            // 节省下内存
            item.changeset = '';
        }
        else {
            item.changeset = userChange.changeset;
        }
        return item;
    };
    /**
     * 构造和 servermessage 一样的包头
     */
    BigDataChannel.prototype.createServerMessageHead = function (newChanges) {
        return {
            base_rev: newChanges.new_rev - 1,
            docid: this.options.serverVars.globalPadId,
            dver: this.options.serverVars.dver,
            new_rev: newChanges.new_rev,
            session_type: sessionType,
            type: "USER_CHANGES" /* USER_CHANGES */,
            uid: this.options.uid,
            uuid: this.options.uuId,
        };
    };
    /**
     * 构造和 servermessage 一样的包体
     */
    BigDataChannel.prototype.createServerMessageBody = function (newChanges) {
        var _a;
        return {
            data: {
                apool: newChanges.apool,
                author: newChanges.author,
                changeset: newChanges.changeset,
                commitId: newChanges.commitId,
                head: newChanges.head,
                isWorkbook: newChanges.isWorkbook || false,
                need: newChanges.need,
                revert: newChanges.revert,
                subId: (_a = newChanges.subId) !== null && _a !== void 0 ? _a : newChanges.subid,
                newRev: newChanges.newRev,
                new_rev: newChanges.newRev,
                type: newChanges.type,
                uuId: this.options.uuId,
            },
        };
    };
    /**
     * 构造和 servermessage 一样的推送包消息结构
     */
    BigDataChannel.prototype.createServerMessage = function (newChanges) {
        var serverMessage = {
            head: this.createServerMessageHead(newChanges),
            body: this.createServerMessageBody(newChanges),
            newRev: newChanges.newRev,
            socketId: '',
        };
        return serverMessage;
    };
    return BigDataChannel;
}());
exports.BigDataChannel = BigDataChannel;
function BuildBigDataChannel(options, dependency) {
    return new BigDataChannel(options, dependency);
}
exports.BuildBigDataChannel = BuildBigDataChannel;
